module.exports = __webpack_public_path__ + "img/8a.439f9fe0.jpg";